module.exports = __webpack_public_path__ + "static/media/pick_provider.773cb23f.svg";